import React from "react";

const ITEMS = [
  ["overview", "Overview"],
  ["information-we-collect", "Information We Collect"],
  ["device-id", "Device Identifier Usage"],
  ["device-permissions", "Device Permissions"],
  ["third-party", "Third-Party Services"],
  ["push-notifications", "Push Notifications"],
  ["data-retention", "Data Retention"],
  ["childrens-privacy", "Children's Privacy"],
  ["your-rights", "Your Rights"],
  ["changes", "Changes to This Policy"],
  ["contact", "Contact Us"]
];

function TableOfContents() {
  return (
    <nav className="toc">
      <h2>Contents</h2>
      <ol>
        {ITEMS.map(([id, label]) => (
          <li key={id}><a href={`#${id}`}>{label}</a></li>
        ))}
      </ol>
    </nav>
  );
}

export default TableOfContents;
